import { useState, useContext, useMemo } from "react"
import { FileUploader } from "react-drag-drop-files"
import { enqueueSnackbar } from 'notistack'
import moment from 'moment-timezone'
import _ from "lodash"

import { Typography, Button, TextField } from "@mui/material"

import { AppContext } from '/providers/app-context'
import {uploadClientImage, saveScannerConfiguration} from '/providers/templates-api'

import StyledPaper from '/components/paper'

const fileTypes = ["jpg", "jpeg", "png"]

const Gift = ({ template, setTemplate }) => {

  const { apiSource, apiKey, setProcessing } = useContext(AppContext)

  const [newScannerData, setNewScannerData] = useState(_.clone(template.scanner_data))
  const [filename, setFilename] = useState()
  const [imageBase64, setImageBase64] = useState(null)

  const dataUnChanged = useMemo(() => JSON.stringify(template.scanner_data) === JSON.stringify(newScannerData),[template.scanner_data,newScannerData])

  const updateScannerData = (field, value) => {
    let sd = _.clone(newScannerData)
    _.set(sd, field, value)
    setNewScannerData(sd)
  }

  const handleImageUpload = file => {
    setFilename(file.name)
    const blobUrl = URL.createObjectURL(file)
    updateScannerData("logo", blobUrl)

    const reader = new FileReader()
    reader.onloadend = () => {
      const b64 = reader.result.replace(/^data:image\/\w+;base64,/, '')
      setImageBase64(b64)
    }
    reader.readAsDataURL(file)
  }

  const save = async () => {
    setProcessing(true)
    enqueueSnackbar({ message: 'Saving configuration', variant: 'light' })

    let sd = _.clone(newScannerData)

    if (imageBase64) {
      const filename2 = await sendImageToS3()
      sd.logo = filename2
    }

    setNewScannerData(sd)

    // Now save to DB
    await saveScannerConfiguration({ apiSource, apiKey, templateId: template.template_id, scannerData:sd })

    enqueueSnackbar({ message: 'Configuration saved', variant: 'success' })
    setProcessing(false)

    setImageBase64(null)

    // Now refresh the scanner data in parent module
    const t = _.cloneDeep(template)
    t.scanner_data = sd
    setTemplate(t)
  }

  const reset = () => {
    setNewScannerData(_.clone(template.scanner_data))
  }

  const sendImageToS3 = async () => {
    const fileData = filename.split(".")
    const suffix = fileData.pop()
    const prefix = fileData.join(".").replace(/[^A-Z0-9-]/ig, "-")

    const timestamp = moment().format("YYYYMMDDHHmmss")

    const uniqueFilename = `${prefix}-${timestamp}.${suffix}`

    // Now upload to S3 (apiSource,apiKey,device,imageType, passType,filename,base64Data)
    const response = await uploadClientImage({ apiSource, apiKey, device:"scan", imageType:"logo",filename: uniqueFilename, base64Data:imageBase64 })
    //TODO handler error

    // And return full URL
    return response.image.s3_url
  }

  if (template.pass_type_id === "managed_gift") return (
    <>
      <Typography variant="h5">Gift card configuration</Typography>
      <StyledPaper classes="mt-2 mb-10">
        <div className="flex flex-col gap-5">
          <Typography variant="h6">Replace logo...</Typography>
          <FileUploader handleChange={handleImageUpload} types={fileTypes} label="Click to select image, or drag an image here (1200x400)" />
          <div style={{ backgroundColor: "white" }}><img src={newScannerData.logo} width="100%" /></div>
        </div>

        <div className="flex w-full justify-between">
          <Button onClick={reset} disabled={dataUnChanged}>Undo changes</Button>
          <Button onClick={save} disabled={dataUnChanged}>Save changes</Button>
        </div>

      </StyledPaper>

      <div className="p-5" />
    </>
  )
}

export default Gift